import { TPageType } from '../../types/page';
import { IApplicationState } from '../../types/redux';

export function selectPageType(state: IApplicationState): TPageType {
  return state.page.type;
}
